// src/pages/AdminUsuarios/AdminUsuarios.js
import React, { useState } from 'react';
import { auth } from '../../auth/AuthService'; // Importa o 'auth' para pegar o token
import { Link } from 'react-router-dom';
import './AdminUsuarios.css';

function AdminUsuarios() {
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('vendedor'); // Define 'vendedor' como padrão
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleSetUserRole = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    const currentUser = auth.currentUser;
    if (!currentUser) {
      setMessage({ type: 'error', text: 'Erro: Você precisa estar logado como administrador.' });
      setLoading(false);
      return;
    }

    if (!email) {
      setMessage({ type: 'error', text: 'Por favor, insira um endereço de e-mail.' });
      setLoading(false);
      return;
    }

    try {
      // 1. Obter o token de ID do administrador logado.
      // Este token prova para a Cloud Function que a chamada é legítima.
      const idToken = await currentUser.getIdToken();

      // ***** IMPORTANTE: SUBSTITUA PELA URL REAL DA SUA FUNÇÃO *****
      const functionUrl = 'https://us-central1-meu-pdv-app-050725.cloudfunctions.net/setUserRole';

      // 2. Chamar a Cloud Function de forma segura
      const response = await fetch(functionUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`, // Envia o token para autorização
        },
        body: JSON.stringify({ email: email, role: role }),
      });

      const data = await response.json();

      if (!response.ok) {
        // Se a resposta não for 'ok', lança um erro com a mensagem do backend
        throw new Error(data.error || 'Ocorreu um erro desconhecido.');
      }

      setMessage({ type: 'success', text: data.message });
      setEmail(''); // Limpa o campo de e-mail após o sucesso

    } catch (error) {
      console.error('Erro ao chamar a função para definir a função:', error);
      setMessage({ type: 'error', text: `Falha ao definir função: ${error.message}` });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-usuarios-container">
      <h2>Gerenciar Funções de Usuários</h2>
      <p className="description">
        Use esta página para atribuir a função de "Administrador" ou "Vendedor" a um usuário existente.
        O usuário precisará fazer logout e login novamente para que a alteração tenha efeito.
      </p>

      <div className="financas-nav-links">
        <Link to="/pdv" className="voltar-btn">← Voltar para o PDV</Link>
      </div>

      <form onSubmit={handleSetUserRole} className="role-form">
        <div className="form-group">
          <label htmlFor="email">E-mail do Usuário:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="exemplo@email.com"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="role">Atribuir a Função de:</label>
          <select id="role" value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="vendedor">Vendedor</option>
            <option value="admin">Administrador</option>
          </select>
        </div>

        <button type="submit" disabled={loading} className="submit-btn">
          {loading ? 'Atribuindo...' : 'Salvar Função'}
        </button>
      </form>

      {message.text && (
        <div className={`message ${message.type}`}>
          {message.text}
        </div>
      )}
    </div>
  );
}

export default AdminUsuarios;